<template>
    <div class="row">
        <div class="small-12 columns" :class="{ error: showManufacturerIdErrorText }">
            <label>
                Hersteller des Fahrzeugs
                <select v-model="formData.manufacturer_id">
                    <option
                        v-for="manufacturer in vehicleManufacturers"
                        :key="manufacturer.id"
                        :value="manufacturer.id"
                    >
                        {{manufacturer.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showManufacturerIdErrorText">
                {{ manufacturerIdErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showEmissionsTypeErrorText }">
            <label>
                Abgasnorm
                <select v-model="formData.emissions_type">
                    <option
                        v-for="emissionsType in availableEmissionsTypes"
                        :key="emissionsType.value"
                        :value="emissionsType.value"
                    >
                        {{emissionsType.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showEmissionsTypeErrorText">
                {{ emissionsTypeErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showIsVehicleSoldErrorText }">
            <label>
                Wurde das Fahrzeug bereits wieder verkauft?
                <select v-model="formData.is_vehicle_sold">
                    <option
                        v-for="selectValue in defaultSelectValues"
                        :key="selectValue.value"
                        :value="selectValue.value"
                    >
                        {{selectValue.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showIsVehicleSoldErrorText">
                {{ isVehicleSoldErrorText }}
            </small>
        </div>
        <div v-if="showMileageInput" class="small-12 columns" :class="{ error: showMileageErrorText }">
            <label>
                {{ mileageLabel }}
                <input type="number" v-model="formData.mileage"/>
            </label>
            <small class="error" v-if="showMileageErrorText">
                {{ mileageErrorText }}
            </small>
        </div>
    </div>
</template>

<script>
import TypeHelper from '../../helper/TypeHelper';
import Validation from '../../helper/Validation';
import EmissionsType from '../../constants/EmissionsType';

export default {
    name: 'VehicleDataFormStep',
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    mandator_lawform:                       null,
                    mandator_prename:                       null,
                    mandator_surname:                       null,
                    mandator_mail:                          null,
                    mandator_iban:                          null,
                    second_mandator_lawform:                null,
                    second_mandator_prename:                null,
                    second_mandator_surname:                null,
                    manufacturer_id:                        null,
                    purchase_date:                          null,
                    emissions_type:                         null,
                    mileage_purchase:                       null,
                    mileage:                                null,
                    price:                                  null,
                    is_vehicle_sold:                        null,
                    was_new:                                null,
                    selected_compensation:                  null
                }
            }
        },
        vehicleManufacturers: {
            type: Array
        }
    },
    data: () => ({
        formData: {
            manufacturer_id:            null,
            emissions_type:             null,
            mileage:                    null,
            is_vehicle_sold:            null,
        },
        validation: {
            isFormDirty: false,
            isManufacturerIdDirty: false,
            isEmissionsTypeDirty: false,
            isMileageDirty: false,
            isIsVehicleSoldDirty: false
        },
        constants: {
            SELECT_VALUE_YES: {
                value: true,
                title: 'Ja'
            },
            SELECT_VALUE_FALSE: {
                value: false,
                title: 'Nein'
            }
        },
        availableEmissionsTypes: [
            EmissionsType.EMISSIONS_TYPE_4,
            EmissionsType.EMISSIONS_TYPE_5,
            EmissionsType.EMISSIONS_TYPE_6A,
            EmissionsType.EMISSIONS_TYPE_6B,
            EmissionsType.EMISSIONS_TYPE_6C,
        ]
    }),
    computed: {
        showMileageInput()
        {
            return TypeHelper.isNotNullOrUndefined(this.formData.is_vehicle_sold);
        },
        mileageLabel()
        {
            if (this.formData.is_vehicle_sold)
                return 'Kilometerstand bei Verkauf';

            return 'Aktueller Kilometerstand';
        },
        defaultSelectValues()
        {
            return [
                this.constants.SELECT_VALUE_YES,
                this.constants.SELECT_VALUE_FALSE
            ];
        },
        showManufacturerIdErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isManufacturerIdDirty)
                && TypeHelper.isNotNullOrUndefined(this.manufacturerIdErrorText);
        },
        showEmissionsTypeErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isEmissionsTypeDirty)
                && TypeHelper.isNotNullOrUndefined(this.emissionsTypeErrorText);
        },
        showIsVehicleSoldErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isIsVehicleSoldDirty)
                && TypeHelper.isNotNullOrUndefined(this.isVehicleSoldErrorText);
        },
        showMileageErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMileageDirty)
                && TypeHelper.isNotNullOrUndefined(this.mileageErrorText);
        },
        manufacturerIdErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.manufacturer_id, validators);
        },
        emissionsTypeErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.emissions_type, validators);
        },
        isVehicleSoldErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.is_vehicle_sold, validators);
        },
        mileageErrorText()
        {
            let validators = [];

            if (this.showMileageInput)
                validators.push(Validation.isNotNull, Validation.isNumeric);

            return Validation.runValidation(this.formData.mileage, validators);
        }
    },
    methods: {
        validate()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        isFormValid()
        {
            let isValid = true;

            isValid = isValid && (this.manufacturerIdErrorText === null);
            isValid = isValid && (this.emissionsTypeErrorText === null);
            isValid = isValid && (this.isVehicleSoldErrorText === null);
            isValid = isValid && (this.mileageErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeCaseData', this.formData);
        }
    },
    watch: {
        'formData.manufacturer_id': function()
        {
            this.validation.isManufacturerIdDirty = true;
        },
        'formData.emissions_type': function()
        {
            this.validation.isEmissionsTypeDirty = true;
        },
        'formData.is_vehicle_sold': function ()
        {
            this.formData.mileage = null;
            this.validation.isIsVehicleSoldDirty = true;
        },
        'formData.mileage': function()
        {
            this.validation.isMileageDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        },
    }
};
</script>

<style scoped>
    .error label {
        color: #4d4d4d;
    }

    select {
        margin: 0 0 1rem;
    }

    .error select {
        margin-bottom: 0;
    }

    .v3dp__datepicker {
        --vdp-hover-bg-color: #e10065;
        --vdp-selected-bg-color: #e10065;
    }
</style>
